import React, {useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {CoverageSummaryModal} from './modal';
import {faFile} from '@fortawesome/fontawesome-pro-solid';
import {useTracking} from '../../../../services/analytics/TrackingContext';

/**
 * Wrapper component to handle state for the coverage summary modal
 */
export const CoverageSummary = ({rowData, column, styleSheet}) => {
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const {trackResultClick} = useTracking();

  const handleCoverageSummaryModal = (e) => {
    e.preventDefault();
    if (rowData) {
      trackResultClick('coverage_summary', rowData);
    }
    setShowSummaryModal(true);
  };

  switch (column.meta?.handler) {
    case 'modal':
    default:
      return (
        <>
          <a
            id={rowData.id}
            onClick={handleCoverageSummaryModal}
            data-testid={`coverage-summary-link-${rowData.id}`}
            title={column.meta.title}
            role='button'
            tabIndex={0}
            onKeyDown={(e) => ((e.key === 'Enter') && handleCoverageSummaryModal(e))}
          >
            <FontAwesomeIcon icon={faFile} size={'2x'} />
          </a>
          <CoverageSummaryModal
            column={column}
            rowData={rowData}
            styleSheet={styleSheet}
            showSummaryModal={showSummaryModal}
            handleHide={() => setShowSummaryModal(false)}
          />
        </>
      );
  }
};
